export default __webpack_public_path__ + "static/41-af817b8028ab804bd507d7842cdbb4a7.png";